export default __webpack_public_path__ + "static/media/aequalis12.74ac6aa0.pdf";